import React from 'react';
const UploadFileSVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      width="27"
      height="30"
      viewBox="0 0 27 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.97368 1.42105C3.01162 1.42105 1.42105 3.01162 1.42105 4.97368V24.8684C1.42105 26.8305 3.01162 28.4211 4.97368 28.4211H22.0263C23.9884 28.4211 25.5789 26.8305 25.5789 24.8684V10.7803C25.5789 9.94923 25.2876 9.14445 24.7556 8.50598L19.9166 2.69935C19.2416 1.88937 18.2418 1.42105 17.1875 1.42105H4.97368ZM0 4.97368C0 2.22679 2.22679 0 4.97368 0H17.1875C18.6635 0 20.0634 0.655645 21.0083 1.7896L25.8472 7.59625C26.592 8.49009 27 9.61679 27 10.7803V24.8684C27 27.6153 24.7732 29.8421 22.0263 29.8421H4.97368C2.22679 29.8421 0 27.6153 0 24.8684V4.97368Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7633 0.710449C18.1556 0.710449 18.4738 1.02857 18.4738 1.42098V6.39466C18.4738 8.35672 20.0644 9.94729 22.0264 9.94729H25.5791C25.9714 9.94729 26.2896 10.2654 26.2896 10.6578C26.2896 11.0502 25.9714 11.3683 25.5791 11.3683H22.0264C19.2795 11.3683 17.0527 9.14155 17.0527 6.39466V1.42098C17.0527 1.02857 17.3709 0.710449 17.7633 0.710449Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8445 16.8447C16.567 17.1221 16.1171 17.1221 15.8395 16.8447L14.2104 15.2154V22.0264C14.2104 22.4187 13.8923 22.7369 13.4999 22.7369C13.1075 22.7369 12.7894 22.4187 12.7894 22.0264V15.2154L11.1603 16.8447C10.8827 17.1221 10.4329 17.1221 10.1554 16.8447C9.87789 16.5671 9.87789 16.1172 10.1554 15.8397L12.9974 12.9976C13.2749 12.7202 13.7249 12.7202 14.0024 12.9976L16.8445 15.8397C17.1219 16.1172 17.1219 16.5671 16.8445 16.8447Z"
        fill={color}
      />
    </svg>
  );
};

export default UploadFileSVG;
